import 'vue-svgicon/dist/polyfill'
import Vue from 'vue'
import 'common/ui'
import 'common/registerHooks.js'
import router from './router'
import store from 'store'
import meta from 'vue-meta'
import moment from 'moment'
import api from 'api/http'
import * as filters from 'common/filters'


// Vue.config.productionTip = false

import 'src/style/app.scss'
import App from 'src/views/app'

// directives
import 'common/directives'
// responsive
// import 'common/responsive'

// import all icons
import * as svgicon from 'vue-svgicon'
import 'views/icons'
Vue.use(svgicon, {
    tagName: 'icon'
})

Vue.use(meta, {
    keyName: 'metaInfo'
})

moment.locale('zh-cn')

api(Vue)

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

const FastClick = require('fastclick')
FastClick.attach(document.body)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: (h) => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js